'use strict';
const { getDependencyClass } = require('../../lib/dependencies.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * PhoenixIntersectionNotifier is a web component responsible for emitting custom events
     * based on the element's visibilty within the viewport.
     *
     * threshold: Value should be between 0 - 1
     * breakpoints: List of breakpoints, you want these events to emitted
     *
     * @example
     *  <phoenix-intersection-notifier
     *      in-view="{InViewEventName}"
     *      out-of-view="{OutOfViewEventName}"
     *      threshold="{value}"
     *      breakpoints="A,B,C">
     *  </phoenix-intersection-notifier>
     *
     */

    class PhoenixIntersectionNotifier extends pageClass.PhoenixElement {
        connectedCallback() {
            let breakpoints = (this.getAttr('breakpoints') || 'A,B,C,D').toUpperCase().split(',');
            if (!breakpoints.includes(pageClass.util.getCurrentBreakpoint())) {
                return;
            }
            this.inViewMessage = this.getAttr('in-view');
            this.outOfViewMessage = this.getAttr('out-of-view');
            let visibilityThreshold = parseFloat(this.getAttr('threshold') || 1);

            this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (breakpoints.includes(pageClass.util.getCurrentBreakpoint())) {
                            this.notify(entry.isIntersecting);
                        }
                    });
                },
                {
                    rootMargin: '0px',
                    threshold: visibilityThreshold,
                }
            );

            this.observer.observe(this);
        }

        notify(isIntersecting) {
            let eventName =
                isIntersecting && this.inViewMessage
                    ? this.inViewMessage
                    : !isIntersecting && this.outOfViewMessage
                    ? this.outOfViewMessage
                    : false;

            if (eventName) {
                this.emitEvent(eventName, {
                    bubbles: true,
                    detail: {
                        key: eventName,
                    },
                });
            }
        }

        disconnectedCallback() {
            this.observer.unobserve(this);
        }
    }

    window.customElements.define('phoenix-intersection-notifier', PhoenixIntersectionNotifier);
});
